/**
 * 2019/1/15
 * 作者:lzq
 *功能: 资源管理模块
 */
export default {
  $getway: 'sysapi',
  getResourceList: 'resource/list',
  saveResource: 'resource/save',
  updateResourceStatus: 'resource/open',
  updateResource: 'resource/update',
  deleteResource: 'resource/delete',
  getAllComments: 'resource/selectComponent'
};
